export default "__VITE_ASSET__D6hX5q0v__"